module.exports = __webpack_public_path__ + "static/media/dot.9b6d436b.svg";